import Dashboard from '../containers/dashboard'
import PaymentsToReviewManagement from '../containers/payments-to-review-management'

const DocumentNoveltiesDetails = () => {
  return (
    <Dashboard>
      <PaymentsToReviewManagement />
    </Dashboard>
  )
}

export default DocumentNoveltiesDetails
